import { inject, Injectable, signal } from '@angular/core';
import { catchError, of } from 'rxjs';
import { ESportFooter, IFooter } from '../models/footer.model';
import { ESportsApiV1 } from '../models/sports.model';
import { FsApiService } from './auth/fs-api.service';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private fsApi = inject(FsApiService);
  private translationService = inject(TranslationService);
  selectedSport = signal<ESportsApiV1>(ESportsApiV1.FOOTBALL);

  footerVisible = signal(false);

  isLoadingFooter = signal<boolean>(false);
  isErrorFooter = signal<boolean>(false);
  footer = signal<IFooter[] | null>(null);

  getFooter(callback?: () => void) {
    this.isLoadingFooter.set(true);
    this.isErrorFooter.set(false);

    this.fsApi
      .get<IFooter | null>(`/footers/`, {
        params: {
          language: this.translationService.getLangLocalStorage(),
        },
      })
      .pipe(
        catchError((_) => {
          this.isLoadingFooter.set(false);
          this.isErrorFooter.set(true);

          return of(null);
        })
      )
      .subscribe((data: any) => {
        if (!data) {
          this.footer.set(null);
          return;
        }

        this.footer.set(data.Footers as IFooter[]);
        callback && callback();
        this.isLoadingFooter.set(false);
      });
  }

  handleDescriptionBySport(sport: ESportsApiV1) {
    switch (sport) {
      case ESportsApiV1.FOOTBALL:
        return this.getDescripcionBySport(ESportFooter.FOOTBALL) ?? '';

      case ESportsApiV1.BASKETBALL:
        return this.getDescripcionBySport(ESportFooter.BASKETBALL) ?? '';
      case ESportsApiV1.BASEBALL:
        return this.getDescripcionBySport(ESportFooter.BASEBALL) ?? '';
      case ESportsApiV1.VOLLEYBALL:
        return this.getDescripcionBySport(ESportFooter.VOLLEYBALL) ?? '';
      case ESportsApiV1.HOCKEY:
        return this.getDescripcionBySport(ESportFooter.ICE_HOCKEY) ?? '';
      case ESportsApiV1.HANDBALL:
        return this.getDescripcionBySport(ESportFooter.HANDBALL) ?? '';
      case ESportsApiV1.AMERICAN_FOOTBALL:
        return this.getDescripcionBySport(ESportFooter.AMERICAN_FOOTBALL) ?? '';
      // case 'Tenis':
      //   return this.getDescripcionBySport(ESportFooter.TENIS);
      // case 'Ganadazo':
      //   return this.getDescripcionBySport(ESportFooter.FOOTBALL);

      default:
        return '';
    }
  }
  // handleDescriptionBySport(sport: EAllSports) {
  //   switch (sport) {
  //     case 'Futbol':
  //       return this.getDescripcionBySport(ESportFooter.FOOTBALL) ?? 'Futbol';

  //     case 'Basket':
  //       return this.getDescripcionBySport(ESportFooter.BASKETBALL) ?? 'Basket';
  //     case 'Beisbol':
  //       return this.getDescripcionBySport(ESportFooter.BASEBALL) ?? 'Beisbol';
  //     case 'Voleibol':
  //       return (
  //         this.getDescripcionBySport(ESportFooter.VOLLEYBALL) ?? 'Voleibol'
  //       );
  //     case 'Hockey':
  //       return this.getDescripcionBySport(ESportFooter.ICE_HOCKEY) ?? 'Hockey';
  //     case 'Balonmano':
  //       return this.getDescripcionBySport(ESportFooter.HANDBALL) ?? 'Balonmano';
  //     case 'FutbolAmericano':
  //       return (
  //         this.getDescripcionBySport(ESportFooter.AMERICAN_FOOTBALL) ??
  //         'FutbolAmericano'
  //       );
  //     // case 'Tenis':
  //     //   return this.getDescripcionBySport(ESportFooter.TENIS);
  //     // case 'Ganadazo':
  //     //   return this.getDescripcionBySport(ESportFooter.FOOTBALL);

  //     default:
  //       return '';
  //   }
  // }

  getDescripcionBySport(sport: ESportFooter) {
    if (this.footer() === null || this.footer()?.length === 0) {
      return '';
    }

    return (
      this.footer()?.filter((item) => item.Sport === sport)[0]?.Description ??
      ''
    );
  }
}
